const screenSizes = {
  mobile: "767px",
  tablet: "1450px"
};

export default screenSizes;
